import { create } from 'zustand';

export type Screen = 'onboarding' | 'core' | 'quick-add';
export type OnboardingStep = 'mode-select' | 'capture' | 'confirmation';

interface UIState {
  screen: Screen;
  onboardingStep: OnboardingStep;
  onboardingMode: 'braindump' | 'conversational' | null;
  debugPanelOpen: boolean;

  setScreen: (screen: Screen) => void;
  setOnboardingStep: (step: OnboardingStep) => void;
  setOnboardingMode: (mode: 'braindump' | 'conversational') => void;
  toggleDebugPanel: () => void;
  openQuickAdd: () => void;
  closeQuickAdd: () => void;
}

export const useUIStore = create<UIState>(set => ({
  screen: 'core',
  onboardingStep: 'mode-select',
  onboardingMode: null,
  debugPanelOpen: false,

  setScreen: screen => { set({ screen }); },
  setOnboardingStep: step => { set({ onboardingStep: step }); },
  setOnboardingMode: mode => { set({ onboardingMode: mode }); },
  toggleDebugPanel: () => { set(s => ({ debugPanelOpen: !s.debugPanelOpen })); },
  openQuickAdd: () => { set({ screen: 'quick-add' }); },
  closeQuickAdd: () => { set({ screen: 'core' }); },
}));
